export default {
  common: {
    reset: "重置",
    refresh: "刷新",
    edit: "编辑",
    delete: "删除",
    create: "创建",
    update: "更新",
    cancel: "取消",
    confirm: "确定",
    save: "保存",
    search: "搜索",
    all: "全部",
    yes: "是",
    no: "否",
    unnamed: "未命名",
  },
  app: {
    title: "JSONBin.io 数据管理",
    description: "管理和编辑你的 JSONBin.io Bins",
    tokenRequired: "请先设置 JSONBin.io Token 以开始使用",
  },
  tokenPrompt: {
    title: "需要 API Token",
    description: "要使用此工具管理你的 JSONBin.io Bins，请先获取并设置你的 Master Key。登录或注册 JSONBin.io 账户后，在 API Keys 页面即可获取。",
    getToken: "获取 API Token",
    visitSite: "访问 JSONBin.io",
  },
  token: {
    title: "JSONBin.io Token",
    notSet: "未设置 Token",
    edit: "编辑",
    delete: "删除",
    placeholder: "输入你的 JSONBin.io Master Key",
    saveSuccess: "Token 保存成功",
    deleteSuccess: "Token 已删除",
    deleteConfirm: "确定要删除 Token 吗？删除后需要重新设置才能使用。",
    deleteTitle: "确认删除",
  },
  binTable: {
    title: "Bin 列表",
    createNew: "创建新 Bin",
    name: "名称",
    binId: "Bin ID",
    createdAt: "创建时间",
    private: "私有",
    operations: "操作",
    namePlaceholder: "搜索名称",
    idPlaceholder: "搜索 Bin ID",
    dateRangeLabel: "创建时间",
    privateLabel: "私有",
    deleteConfirm: "确定要删除这个 Bin 吗？",
    deleteSuccess: "删除成功",
    loadFailed: "加载失败",
    deleteFailed: "删除失败",
    tokenWarning: "请先设置 Token",
    makePrivate: "设为私有",
    makePublic: "设为公开",
    togglePrivateSuccess: "切换成功",
    togglePrivateFailed: "切换失败",
  },
  binEditor: {
    createTitle: "创建新 Bin",
    editTitle: "编辑 Bin",
    nameLabel: "Bin 名称（可选）",
    namePlaceholder: "输入 Bin 名称（仅支持 ASCII 字符）",
    dataLabel: "JSON 数据",
    dataPlaceholder: '输入 JSON 数据，例如: {"key": "value"}',
    privateLabel: "私有",
    privateTooltip: "私有 Bin 需要 Token 才能访问，公开 Bin 任何人都可以访问",
    createSuccess: "创建成功",
    updateSuccess: "更新成功",
    saveFailed: "保存失败",
    loadFailed: "加载失败",
    tokenWarning: "请先设置 Token",
    jsonError: "JSON 格式错误，请检查",
    nameAsciiError: "名称只能包含 ASCII 字符（不支持中文）",
    format: "格式化",
    formatSuccess: "格式化成功",
    fullscreen: "全屏",
    exitFullscreen: "退出全屏",
  },
  theme: {
    normal: "白昼",
    dark: "黑夜",
    tech: "科技",
  },
};
